// extracted by mini-css-extract-plugin
module.exports = {"base":"RecordHistory_base__3GjDg"};